import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import {
  DeleteCategoryMedicalStore,
  GetCategoriesMedicalStore
} from "../../../../api/medicalStore/master/categoryMedicalStoreAPI";

const ListCategoryMedicalStore = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchData = async () => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await GetCategoriesMedicalStore();
      if (response.success) {
        showToast("success", response.message);
        const formattedData = response.data.map((item, index) => ({
          index: index + 1,
          id: item._id,
          name: item.name || "",
          gstItemCode: item.gstItemCode || "",
          purchaseAccount: item.purchaseAccount || "",
          saleCharge: item.saleCharge || "",
          singleUnitIssue: item.singleUnitIssue || ""
        }));
        setData(formattedData);
        setFilteredData(formattedData);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(
    () => {
      const results = data.filter(item =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
      setFilteredData(results);
    },
    [search, data]
  );

  const handleEditClick = id => {
    navigate(`/medical-store/master/category/edit/${id}`);
  };

  const handleDeleteClick = async id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async result => {
      if (result.isConfirmed) {
        dispatch({ type: "LOADER_START" });
        try {
          const response = await DeleteCategoryMedicalStore(id);
          if (response.success) {
            showToast("success", response.message);
            setData(data.filter(item => item.id !== id));
            setFilteredData(filteredData.filter(item => item.id !== id));
          } else {
            showToast("error", response.message);
          }
        } catch (error) {
          showToast("error", error.message);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      }
    });
  };

  const columns = [
    { name: "S.No", selector: row => row.index, width: "10%" },
    {
      name: "Category Name",
      selector: row => row.name,
      sortable: true,
      width: "20%"
    },
    {
      name: "GST Item Code",
      selector: row => row.gstItemCode,
      sortable: true,
      width: "10%"
    },
    {
      name: "Purchase Account",
      selector: row => row.purchaseAccount,
      width: "20%"
    },
    { name: "Sale Charge", selector: row => row.saleCharge, width: "10%" },
    {
      name: "Single Unit Issue",
      selector: row => row.singleUnitIssue,
      width: "10%"
    },
    {
      name: "Actions",
      cell: row =>
        <div>
          <button
            className="btn btn-primary me-2"
            id={`edit-${row.id}`}
            onClick={() => handleEditClick(row.id)}
          >
            <i className="fa fa-pencil" />
          </button>
          <UncontrolledTooltip target={`edit-${row.id}`}>
            Edit
          </UncontrolledTooltip>

          <button
            className="btn btn-danger"
            id={`delete-${row.id}`}
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="fa fa-trash" />
          </button>
          <UncontrolledTooltip target={`delete-${row.id}`}>
            Delete
          </UncontrolledTooltip>
        </div>,
      ignoreRowClick: true,
      button: true,
      width: "20%"
    }
  ];

  const headers = [
    { label: "S.No", key: "index" },
    { label: "Category Name", key: "name" },
    { label: "GST Item Code", key: "gstItemCode" },
    { label: "Purchase Account", key: "purchaseAccount" },
    { label: "Sale Charge", key: "saleCharge" },
    { label: "Single Unit Issue", key: "singleUnitIssue" }
  ];

  const ExportCSV = ({ data }) =>
    <CSVLink
      data={data}
      headers={headers}
      filename="category-medical-store.csv"
    >
      <button className="btn btn-primary mt-1" id="export">
        Export
      </button>
      <UncontrolledTooltip target="export">Export to CSV</UncontrolledTooltip>
    </CSVLink>;

  return (
    <Fragment>
      <Breadcrumb parent="Medical Store" title="Category" />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Category List</h5>
            <Link to={`/medical-store/master/category/add`}>
              <button className="btn btn-primary" id="create">
                Create Category
              </button>
              <UncontrolledTooltip target="create">
                Create Category
              </UncontrolledTooltip>
            </Link>
          </div>

          <div className="row p-3">
            <div className="col-md-6">
              <input
                className="form-control"
                placeholder="Search category..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-6 text-end">
              <ExportCSV data={data} />
            </div>
          </div>

          <div className="card-body">
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListCategoryMedicalStore;
